import template from './modalCancelDelegation.html';
import controller from './modalCancelDelegation.controller';
import './modalCancelDelegation.scss';

let modalCancelDelegationComponent = {
  restrict: 'E',
  bindings: {
    isMobileApp: '<',
    delegation: '<',
    cancelDelegation: '&',
    onDismiss: '&',
  },
  template,
  controller,
};

export default modalCancelDelegationComponent;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalCancelDelegation/modalCancelDelegation.component.js